import get from 'lodash/get';

// Caution! Only valid to call this in DSMP!
export default function() {
  return get(window, 'initialState.revisionSeq');  // populated by dataset_management_ui.html.erb
}
